import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/lukas/Sites/git/own-packages/react-i18n-kit/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from "docz";
import { Translator, DynamicTextHook as DynamicText } from "./components";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Translator heading page="dynamicApproachHook" num="0" mdxType="Translator" />
    <Translator page="dynamicApproachHook" num="0" mdxType="Translator" />
    <Translator page="dynamicApproachHook" num="1" mdxType="Translator" />
    <Translator page="dynamicApproachHook" num="2" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// './i18n/index.js'
const data = {
  de: {
    text: "Hallo Welt!",
  },
  en: {
    text: "Hello World!",
  },
  es: {
    text: "!Hola Mundo!",
  },
};

export { data };
`}</code></pre>
    <Translator page="dynamicApproachHook" num="3" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from "react";
import { useI18n } from "react-i18n-kit";

import { data } from "./i18n";

const DynamicText = () => {
  const { i18n, translate } = useI18n(data, { lang: 'en' });

  return (
    <>
      <button onClick={() => translate("en")}>
        English
      </button>
      <button onClick={() => translate("es")}>
        Español
      </button>
      <button onClick={() => translate("de")}>
        Deutsch
      </button>
      <div>{i18n.text}</div>
    </>
  );
};

export { DynamicText };
`}</code></pre>
    <Translator page="dynamicApproachHook" num="4" mdxType="Translator" />
    <Playground __position={6} __code={'<DynamicText />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Translator,
      DynamicText
    }} mdxType="Playground">
  <DynamicText mdxType="DynamicText" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      